import api from './index';
//
let exports = {};

// 获取-值班任务
exports.getServicerDutyTaskInfo = function (data, callback) {
    api.post('/perform/servicer/duty/task/get')
    .data(data)
    .done(callback)
    .go();
};

// 获取-值班任务列表（针对-某人某月）
exports.getServicerDutyTaskList = function (postData, callback) {
    api.post('/perform/servicer/duty/task/list/get')
    .data(postData)
    .done(callback)
    .go();
};

// 新增-值班任务（针对-某人某月）
exports.saveServicerDutyTask = function (postData, callback) {
    api.post('/perform/servicer/duty/task/save/do')
    .data(postData)
    .done(callback)
    .go();
};

// 更新-值班任务
exports.updateServicerDutyTask = function (postData, callback) {
    api.post('/perform/servicer/duty/task/update/do')
    .data(postData)
    .done(callback)
    .go();
};

//删除-值班任务
exports.deleteServicerDutyTask = function (postData, callback) {
    api.post('/perform/servicer/duty/task/delete/do')
    .data(postData)
    .done(callback)
    .go();
};

// ============================= 多人多天 =============================
// 获取-值班任务列表（针对-某人某月）
exports.getServicerDutyTaskListByFilter = function (postData, callback) {
    api.post('/perform/servicer/duty/task/list/get/by/filter')
    .data(postData)
    .done(callback)
    .go();
};

export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/dutyTask.js
// module id = 115
// module chunks = 1